/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js');
var spine_core_user_id_pb = require('../../spine/core/user_id_pb.js');
var spine_core_tenant_id_pb = require('../../spine/core/tenant_id_pb.js');
var spine_core_actor_context_pb = require('../../spine/core/actor_context_pb.js');
var spine_core_response_pb = require('../../spine/core/response_pb.js');
var spine_client_entities_pb = require('../../spine/client/entities_pb.js');
goog.exportSymbol('proto.spine.client.EntityStateUpdate', null, global);
goog.exportSymbol('proto.spine.client.Subscription', null, global);
goog.exportSymbol('proto.spine.client.SubscriptionId', null, global);
goog.exportSymbol('proto.spine.client.SubscriptionUpdate', null, global);
goog.exportSymbol('proto.spine.client.SubscriptionValidationError', null, global);
goog.exportSymbol('proto.spine.client.Topic', null, global);
goog.exportSymbol('proto.spine.client.TopicId', null, global);
goog.exportSymbol('proto.spine.client.TopicValidationError', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.TopicId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.TopicId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.TopicId.displayName = 'proto.spine.client.TopicId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.TopicId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.TopicId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.TopicId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.TopicId.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.TopicId}
 */
proto.spine.client.TopicId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.TopicId;
  return proto.spine.client.TopicId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.TopicId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.TopicId}
 */
proto.spine.client.TopicId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.TopicId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.TopicId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.TopicId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.TopicId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.spine.client.TopicId.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.client.TopicId.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.Topic = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.Topic, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.Topic.displayName = 'proto.spine.client.Topic';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.Topic.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.Topic.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.Topic} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Topic.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.spine.client.TopicId.toObject(includeInstance, f),
    target: (f = msg.getTarget()) && spine_client_entities_pb.Target.toObject(includeInstance, f),
    fieldMask: (f = msg.getFieldMask()) && google_protobuf_field_mask_pb.FieldMask.toObject(includeInstance, f),
    context: (f = msg.getContext()) && spine_core_actor_context_pb.ActorContext.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.Topic}
 */
proto.spine.client.Topic.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.Topic;
  return proto.spine.client.Topic.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.Topic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.Topic}
 */
proto.spine.client.Topic.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.TopicId;
      reader.readMessage(value,proto.spine.client.TopicId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_client_entities_pb.Target;
      reader.readMessage(value,spine_client_entities_pb.Target.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    case 3:
      var value = new google_protobuf_field_mask_pb.FieldMask;
      reader.readMessage(value,google_protobuf_field_mask_pb.FieldMask.deserializeBinaryFromReader);
      msg.setFieldMask(value);
      break;
    case 4:
      var value = new spine_core_actor_context_pb.ActorContext;
      reader.readMessage(value,spine_core_actor_context_pb.ActorContext.deserializeBinaryFromReader);
      msg.setContext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.Topic.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.Topic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.Topic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Topic.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.client.TopicId.serializeBinaryToWriter
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_client_entities_pb.Target.serializeBinaryToWriter
    );
  }
  f = message.getFieldMask();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_field_mask_pb.FieldMask.serializeBinaryToWriter
    );
  }
  f = message.getContext();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      spine_core_actor_context_pb.ActorContext.serializeBinaryToWriter
    );
  }
};


/**
 * optional TopicId id = 1;
 * @return {?proto.spine.client.TopicId}
 */
proto.spine.client.Topic.prototype.getId = function() {
  return /** @type{?proto.spine.client.TopicId} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.TopicId, 1));
};


/** @param {?proto.spine.client.TopicId|undefined} value */
proto.spine.client.Topic.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.Topic.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Topic.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Target target = 2;
 * @return {?proto.spine.client.Target}
 */
proto.spine.client.Topic.prototype.getTarget = function() {
  return /** @type{?proto.spine.client.Target} */ (
    jspb.Message.getWrapperField(this, spine_client_entities_pb.Target, 2));
};


/** @param {?proto.spine.client.Target|undefined} value */
proto.spine.client.Topic.prototype.setTarget = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.client.Topic.prototype.clearTarget = function() {
  this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Topic.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.FieldMask field_mask = 3;
 * @return {?proto.google.protobuf.FieldMask}
 */
proto.spine.client.Topic.prototype.getFieldMask = function() {
  return /** @type{?proto.google.protobuf.FieldMask} */ (
    jspb.Message.getWrapperField(this, google_protobuf_field_mask_pb.FieldMask, 3));
};


/** @param {?proto.google.protobuf.FieldMask|undefined} value */
proto.spine.client.Topic.prototype.setFieldMask = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.client.Topic.prototype.clearFieldMask = function() {
  this.setFieldMask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Topic.prototype.hasFieldMask = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional spine.core.ActorContext context = 4;
 * @return {?proto.spine.core.ActorContext}
 */
proto.spine.client.Topic.prototype.getContext = function() {
  return /** @type{?proto.spine.core.ActorContext} */ (
    jspb.Message.getWrapperField(this, spine_core_actor_context_pb.ActorContext, 4));
};


/** @param {?proto.spine.core.ActorContext|undefined} value */
proto.spine.client.Topic.prototype.setContext = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.client.Topic.prototype.clearContext = function() {
  this.setContext(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Topic.prototype.hasContext = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.SubscriptionUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.client.SubscriptionUpdate.repeatedFields_, null);
};
goog.inherits(proto.spine.client.SubscriptionUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.SubscriptionUpdate.displayName = 'proto.spine.client.SubscriptionUpdate';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.client.SubscriptionUpdate.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.SubscriptionUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.SubscriptionUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.SubscriptionUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.SubscriptionUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscription: (f = msg.getSubscription()) && proto.spine.client.Subscription.toObject(includeInstance, f),
    response: (f = msg.getResponse()) && spine_core_response_pb.Response.toObject(includeInstance, f),
    entityStateUpdatesList: jspb.Message.toObjectList(msg.getEntityStateUpdatesList(),
    proto.spine.client.EntityStateUpdate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.SubscriptionUpdate}
 */
proto.spine.client.SubscriptionUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.SubscriptionUpdate;
  return proto.spine.client.SubscriptionUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.SubscriptionUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.SubscriptionUpdate}
 */
proto.spine.client.SubscriptionUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.Subscription;
      reader.readMessage(value,proto.spine.client.Subscription.deserializeBinaryFromReader);
      msg.setSubscription(value);
      break;
    case 2:
      var value = new spine_core_response_pb.Response;
      reader.readMessage(value,spine_core_response_pb.Response.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 11:
      var value = new proto.spine.client.EntityStateUpdate;
      reader.readMessage(value,proto.spine.client.EntityStateUpdate.deserializeBinaryFromReader);
      msg.addEntityStateUpdates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.SubscriptionUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.SubscriptionUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.SubscriptionUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.SubscriptionUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscription();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.client.Subscription.serializeBinaryToWriter
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_response_pb.Response.serializeBinaryToWriter
    );
  }
  f = message.getEntityStateUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.spine.client.EntityStateUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional Subscription subscription = 1;
 * @return {?proto.spine.client.Subscription}
 */
proto.spine.client.SubscriptionUpdate.prototype.getSubscription = function() {
  return /** @type{?proto.spine.client.Subscription} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.Subscription, 1));
};


/** @param {?proto.spine.client.Subscription|undefined} value */
proto.spine.client.SubscriptionUpdate.prototype.setSubscription = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.SubscriptionUpdate.prototype.clearSubscription = function() {
  this.setSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.SubscriptionUpdate.prototype.hasSubscription = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Response response = 2;
 * @return {?proto.spine.core.Response}
 */
proto.spine.client.SubscriptionUpdate.prototype.getResponse = function() {
  return /** @type{?proto.spine.core.Response} */ (
    jspb.Message.getWrapperField(this, spine_core_response_pb.Response, 2));
};


/** @param {?proto.spine.core.Response|undefined} value */
proto.spine.client.SubscriptionUpdate.prototype.setResponse = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.client.SubscriptionUpdate.prototype.clearResponse = function() {
  this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.SubscriptionUpdate.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated EntityStateUpdate entity_state_updates = 11;
 * @return {!Array<!proto.spine.client.EntityStateUpdate>}
 */
proto.spine.client.SubscriptionUpdate.prototype.getEntityStateUpdatesList = function() {
  return /** @type{!Array<!proto.spine.client.EntityStateUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.spine.client.EntityStateUpdate, 11));
};


/** @param {!Array<!proto.spine.client.EntityStateUpdate>} value */
proto.spine.client.SubscriptionUpdate.prototype.setEntityStateUpdatesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.spine.client.EntityStateUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.client.EntityStateUpdate}
 */
proto.spine.client.SubscriptionUpdate.prototype.addEntityStateUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.spine.client.EntityStateUpdate, opt_index);
};


proto.spine.client.SubscriptionUpdate.prototype.clearEntityStateUpdatesList = function() {
  this.setEntityStateUpdatesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.EntityStateUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.EntityStateUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.EntityStateUpdate.displayName = 'proto.spine.client.EntityStateUpdate';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.EntityStateUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.EntityStateUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.EntityStateUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityStateUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    state: (f = msg.getState()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.EntityStateUpdate}
 */
proto.spine.client.EntityStateUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.EntityStateUpdate;
  return proto.spine.client.EntityStateUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.EntityStateUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.EntityStateUpdate}
 */
proto.spine.client.EntityStateUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.EntityStateUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.EntityStateUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.EntityStateUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityStateUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any id = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.client.EntityStateUpdate.prototype.getId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.client.EntityStateUpdate.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.EntityStateUpdate.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.EntityStateUpdate.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Any state = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.client.EntityStateUpdate.prototype.getState = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.client.EntityStateUpdate.prototype.setState = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.client.EntityStateUpdate.prototype.clearState = function() {
  this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.EntityStateUpdate.prototype.hasState = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.SubscriptionId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.SubscriptionId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.SubscriptionId.displayName = 'proto.spine.client.SubscriptionId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.SubscriptionId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.SubscriptionId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.SubscriptionId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.SubscriptionId.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.SubscriptionId}
 */
proto.spine.client.SubscriptionId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.SubscriptionId;
  return proto.spine.client.SubscriptionId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.SubscriptionId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.SubscriptionId}
 */
proto.spine.client.SubscriptionId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.SubscriptionId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.SubscriptionId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.SubscriptionId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.SubscriptionId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.spine.client.SubscriptionId.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.client.SubscriptionId.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.Subscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.Subscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.Subscription.displayName = 'proto.spine.client.Subscription';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.Subscription.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.Subscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Subscription.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.spine.client.SubscriptionId.toObject(includeInstance, f),
    topic: (f = msg.getTopic()) && proto.spine.client.Topic.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.Subscription}
 */
proto.spine.client.Subscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.Subscription;
  return proto.spine.client.Subscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.Subscription}
 */
proto.spine.client.Subscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.SubscriptionId;
      reader.readMessage(value,proto.spine.client.SubscriptionId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new proto.spine.client.Topic;
      reader.readMessage(value,proto.spine.client.Topic.deserializeBinaryFromReader);
      msg.setTopic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.Subscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.Subscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Subscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.client.SubscriptionId.serializeBinaryToWriter
    );
  }
  f = message.getTopic();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.spine.client.Topic.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionId id = 1;
 * @return {?proto.spine.client.SubscriptionId}
 */
proto.spine.client.Subscription.prototype.getId = function() {
  return /** @type{?proto.spine.client.SubscriptionId} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.SubscriptionId, 1));
};


/** @param {?proto.spine.client.SubscriptionId|undefined} value */
proto.spine.client.Subscription.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.Subscription.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Subscription.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Topic topic = 2;
 * @return {?proto.spine.client.Topic}
 */
proto.spine.client.Subscription.prototype.getTopic = function() {
  return /** @type{?proto.spine.client.Topic} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.Topic, 2));
};


/** @param {?proto.spine.client.Topic|undefined} value */
proto.spine.client.Subscription.prototype.setTopic = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.client.Subscription.prototype.clearTopic = function() {
  this.setTopic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Subscription.prototype.hasTopic = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.spine.client.TopicValidationError = {
  TVE_UNKNOWN_REASON: 0,
  UNSUPPORTED_TOPIC_TARGET: 1,
  INVALID_TOPIC: 2
};

/**
 * @enum {number}
 */
proto.spine.client.SubscriptionValidationError = {
  SVE_UNKNOWN_REASON: 0,
  UNSUPPORTED_SUBSCRIPTION_TARGET: 1,
  INVALID_SUBSCRIPTION: 2,
  UNKNOWN_SUBSCRIPTION: 3
};

goog.object.extend(exports, proto.spine.client);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.client.TopicId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.TopicId.fromObject(jsObject);
};

proto.spine.client.TopicId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.TopicId();
  
  if (obj.value !== undefined) {
    if (obj.value !== null) {
      let value = obj.value;
      msg.setValue(value);
    }
  }
  return msg;
};

proto.spine.client.Topic.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.Topic.fromObject(jsObject);
};

proto.spine.client.Topic.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.Topic();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.client.TopicId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.target !== undefined) {
    if (obj.target === null) {
      msg.setTarget(null);
    } else {
      let value = proto.spine.client.Target.fromObject(obj.target);
      msg.setTarget(value);
    }
  }
  
  if (obj.fieldMask !== undefined) {
    if (obj.fieldMask === null) {
      msg.setFieldMask(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.FieldMask');
      let value = parser.parse(obj.fieldMask);
      msg.setFieldMask(value);
    }
  }
  
  if (obj.context !== undefined) {
    if (obj.context === null) {
      msg.setContext(null);
    } else {
      let value = proto.spine.core.ActorContext.fromObject(obj.context);
      msg.setContext(value);
    }
  }
  return msg;
};

proto.spine.client.SubscriptionUpdate.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.SubscriptionUpdate.fromObject(jsObject);
};

proto.spine.client.SubscriptionUpdate.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.SubscriptionUpdate();
  
  if (obj.subscription !== undefined) {
    if (obj.subscription === null) {
      msg.setSubscription(null);
    } else {
      let value = proto.spine.client.Subscription.fromObject(obj.subscription);
      msg.setSubscription(value);
    }
  }
  
  if (obj.response !== undefined) {
    if (obj.response === null) {
      msg.setResponse(null);
    } else {
      let value = proto.spine.core.Response.fromObject(obj.response);
      msg.setResponse(value);
    }
  }
  
  if (obj.entityStateUpdates !== undefined && obj.entityStateUpdates !== null) {
    obj.entityStateUpdates.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addEntityStateUpdates(null);
        } else {
          let value = proto.spine.client.EntityStateUpdate.fromObject(listItem);
          msg.addEntityStateUpdates(value);
        }
      }
    );
  }
  return msg;
};

proto.spine.client.EntityStateUpdate.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.EntityStateUpdate.fromObject(jsObject);
};

proto.spine.client.EntityStateUpdate.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.EntityStateUpdate();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.state !== undefined) {
    if (obj.state === null) {
      msg.setState(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.state);
      msg.setState(value);
    }
  }
  return msg;
};

proto.spine.client.SubscriptionId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.SubscriptionId.fromObject(jsObject);
};

proto.spine.client.SubscriptionId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.SubscriptionId();
  
  if (obj.value !== undefined) {
    if (obj.value !== null) {
      let value = obj.value;
      msg.setValue(value);
    }
  }
  return msg;
};

proto.spine.client.Subscription.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.Subscription.fromObject(jsObject);
};

proto.spine.client.Subscription.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.Subscription();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.client.SubscriptionId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.topic !== undefined) {
    if (obj.topic === null) {
      msg.setTopic(null);
    } else {
      let value = proto.spine.client.Topic.fromObject(obj.topic);
      msg.setTopic(value);
    }
  }
  return msg;
};
